module.exports = __webpack_public_path__ + "static/media/man2.a13e52e7.jpg";